import { render, staticRenderFns } from "./check_products.vue?vue&type=template&id=46b64b28&"
import script from "./check_products.vue?vue&type=script&lang=js&"
export * from "./check_products.vue?vue&type=script&lang=js&"
import style0 from "./check_products.vue?vue&type=style&index=0&id=46b64b28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports